import React from "react";
import "./SelectItemsTable.css";

const SelectItemsTable = ({ items = [] }) => {
  // Default data if none provided
  const defaultItems = [
    {
      id: 1,
      name: "Dashboard A",
      type: "Dashboard A",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 2,
      name: "Dashboard B",
      type: "Dashboard A",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 3,
      name: "Report A",
      type: "Dashboard A",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 4,
      name: "Report B",
      type: "Dashboard A",
      timestamp: "May 21, 2025 12:00 PM",
    },
  ];

  const displayItems = items.length > 0 ? items : defaultItems;

  return (
    <div className="dashboard-items-table-container">
      <div className="table-header">
        <h3 className="table-title">Select the items</h3>
      </div>

      <div className="table-wrapper">
        <table className="dashboard-items-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            {displayItems.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.type}</td>
                <td>{item.timestamp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SelectItemsTable;
